module.exports = __webpack_public_path__ + "static/media/7.71ba60e7.png";